var _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerIcons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1294,
    height: 355,
    viewBox: "0 0 1294 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000.21 339.672H943V350.672H1000.21V339.672Z",
    fill: "#183171"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1040 226.783H982.788V237.784H1040V226.783Z",
    fill: "#183171"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.67 305.447H1101.46V316.448H1158.67V305.447Z",
    fill: "#183171"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1209.99 150.957H1152.78V161.957H1209.99V150.957Z",
    fill: "#183171"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1293.08 243.014H1235.87V254.014H1293.08V243.014Z",
    fill: "#183171"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.122 40.3685L192.004 29.16L182.182 50.1578L177 47.5344L189.342 21.1431L211.463 32.3516L221.818 10.2148L227 12.8383L214.122 40.3685Z",
    fill: "#7879F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2341_11565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1117.33 40.6204L1110.38 29.257C1110.11 28.8097 1110.02 28.2719 1110.14 27.7621C1110.27 27.2523 1110.59 26.8121 1111.04 26.5385C1111.48 26.2649 1112.02 26.1802 1112.53 26.3031C1113.04 26.426 1113.49 26.7463 1113.76 27.1937L1118.68 35.2323L1131.74 27.5063C1131.97 27.3741 1132.22 27.2871 1132.47 27.2504C1132.73 27.2137 1132.99 27.2281 1133.24 27.2926C1133.5 27.3571 1133.73 27.4705 1133.94 27.6263C1134.15 27.7822 1134.32 27.9774 1134.46 28.2009C1134.59 28.4244 1134.68 28.6717 1134.71 28.9288C1134.75 29.1859 1134.74 29.4477 1134.67 29.6993C1134.61 29.9508 1134.49 30.1872 1134.34 30.3949C1134.18 30.6026 1133.98 30.7776 1133.76 30.9099L1117.33 40.6204Z",
    fill: "#35B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122 58.1415C1117.06 58.1415 1112.22 56.6774 1108.11 53.9342C1104 51.1911 1100.8 47.2922 1098.9 42.7306C1097.01 38.169 1096.52 33.1495 1097.48 28.3069C1098.45 23.4643 1100.83 19.0161 1104.32 15.5248C1107.82 12.0335 1112.27 9.65583 1117.12 8.69258C1121.97 7.72933 1127 8.22371 1131.57 10.1132C1136.14 12.0027 1140.04 15.2024 1142.79 19.3078C1145.53 23.4131 1147 28.2397 1147 33.1772C1146.99 39.7957 1144.36 46.1409 1139.67 50.8209C1134.98 55.5009 1128.63 58.1336 1122 58.1415ZM1122 11.7796C1117.76 11.7796 1113.62 13.0346 1110.1 15.3858C1106.57 17.737 1103.82 21.0788 1102.2 24.9887C1100.58 28.8986 1100.16 33.2009 1100.98 37.3516C1101.81 41.5024 1103.85 45.3151 1106.85 48.3076C1109.84 51.3001 1113.66 53.338 1117.82 54.1636C1121.98 54.9892 1126.28 54.5655 1130.2 52.946C1134.12 51.3264 1137.46 48.5839 1139.82 45.065C1142.17 41.5462 1143.43 37.4092 1143.43 33.1772C1143.42 27.5023 1141.17 22.0607 1137.15 18.0469C1133.13 14.0332 1127.68 11.7752 1122 11.7687V11.7796Z",
    fill: "#35B86D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2341_11565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1202.53 330.279L1178.37 322.674C1176.07 321.947 1174.15 320.336 1173.03 318.195C1171.91 316.054 1171.69 313.557 1172.42 311.255L1180.04 287.134C1180.4 285.995 1180.98 284.937 1181.75 284.021C1182.52 283.106 1183.46 282.351 1184.52 281.799C1185.59 281.248 1186.75 280.91 1187.94 280.806C1189.13 280.702 1190.33 280.834 1191.47 281.193L1215.63 288.798C1217.94 289.524 1219.86 291.136 1220.97 293.277C1222.09 295.418 1222.31 297.915 1221.58 300.217L1213.96 324.337C1213.6 325.477 1213.02 326.535 1212.25 327.45C1211.48 328.366 1210.54 329.121 1209.48 329.672C1208.42 330.224 1207.26 330.562 1206.06 330.666C1204.87 330.77 1203.67 330.638 1202.53 330.279Z",
    fill: "#2D4993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.8 314.459L1185.19 302.01C1184.91 301.52 1184.84 300.943 1184.98 300.4C1185.12 299.857 1185.47 299.39 1185.95 299.097C1186.43 298.805 1187 298.709 1187.55 298.831C1188.1 298.953 1188.58 299.282 1188.89 299.75L1194.27 308.555L1208.59 300.094C1209.08 299.827 1209.66 299.761 1210.2 299.91C1210.74 300.059 1211.2 300.412 1211.49 300.894C1211.77 301.375 1211.86 301.949 1211.73 302.494C1211.6 303.039 1211.27 303.513 1210.8 303.816L1192.8 314.459Z",
    fill: "#DBE5FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_2341_11565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.8603 313.069L41.4142 325.419C39.4622 326.597 37.1218 326.953 34.9075 326.408C32.6932 325.863 30.7861 324.462 29.6055 322.513L17.2394 302.113C16.0602 300.163 15.7042 297.826 16.2499 295.614C16.7955 293.403 18.1981 291.498 20.1493 290.319L40.5916 277.969C41.5578 277.385 42.6296 276.997 43.746 276.827C44.8623 276.657 46.0013 276.708 47.0978 276.977C48.1944 277.247 49.227 277.729 50.1368 278.398C51.0466 279.066 51.8157 279.906 52.4003 280.871L64.7664 301.291C65.9411 303.239 66.2948 305.572 65.7501 307.78C65.2054 309.988 63.8066 311.89 61.8603 313.069Z",
    fill: "#35B86D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.574 310.095L30.9971 307.723C30.7326 307.676 30.4798 307.578 30.2532 307.434C30.0266 307.29 29.8306 307.103 29.6764 306.884C29.5222 306.664 29.4128 306.416 29.3545 306.155C29.2961 305.893 29.29 305.622 29.3365 305.358C29.3829 305.094 29.481 304.841 29.6251 304.615C29.7693 304.389 29.9566 304.193 30.1765 304.039C30.3964 303.885 30.6445 303.776 30.9066 303.717C31.1688 303.659 31.4398 303.653 31.7044 303.699L41.3143 305.373L44.2319 289.975C44.2824 289.711 44.3844 289.46 44.532 289.236C44.6797 289.011 44.8702 288.818 45.0925 288.667C45.3149 288.517 45.5649 288.411 45.8281 288.357C46.0913 288.302 46.3627 288.3 46.6267 288.351C46.8907 288.401 47.1422 288.503 47.3668 288.651C47.5914 288.798 47.7847 288.988 47.9357 289.21C48.0867 289.432 48.1924 289.682 48.2468 289.945C48.3012 290.208 48.3032 290.479 48.2527 290.743L44.574 310.095Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2341_11565",
    x: 1081,
    y: 0.212891,
    width: 82,
    height: 81.9277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380226 0 0 0 0 0.442196 0 0 0 0 0.504167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2341_11565"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2341_11565",
    result: "effect2_dropShadow_2341_11565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2341_11565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2341_11565",
    x: 1156,
    y: 272.771,
    width: 82.002,
    height: 81.9277,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380226 0 0 0 0 0.442196 0 0 0 0 0.504167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2341_11565"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2341_11565",
    result: "effect2_dropShadow_2341_11565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2341_11565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_2341_11565",
    x: 0,
    y: 268.729,
    width: 82,
    height: 81.9297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380226 0 0 0 0 0.442196 0 0 0 0 0.504167 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2341_11565"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2341_11565",
    result: "effect2_dropShadow_2341_11565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2341_11565",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcons);
export default __webpack_public_path__ + "static/media/banner-icons.eabc4638e2aaea289b38b992d0969d47.svg";
export { ForwardRef as ReactComponent };